<template>
  <div class="caseStatistics">
    <div class="top wbg" v-if="$common.AUTH('statis:causeFee:lists')">
      <a-row class="row" :gutter="20">
        <a-col class="flex" :span="5">
          <label>委托类型：</label>
          <a-select placeholder="请选择委托类型" class="select">
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择原告" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='6' allowClear :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id" :title="item.title">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>管辖法院：</label>
          <a-select v-model="form.court_id" placeholder="请选择管辖法院" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='6' @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
            :filter-option="false" :not-found-content="null" allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id" :title="item.title">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7" class="flex">
          <label>日期：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="20" style="margin-bottom:0;">
        <a-col :span="5" class="flex">
          <label>案件类型：</label>
          <a-select class="select" v-model='form.cause_type' placeholder="请选择案件类型" allowClear>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="2">仲裁</a-select-option>
            <a-select-option :value="3" disabled>公证</a-select-option>
            <a-select-option :value="4" disabled>调解</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8" class="flex">
          <a-button icon="search" style="height:32px;" @click='page.page = 1; query()'>查询</a-button>
          <a-button style="height:32px;margin-left: 20px;" @click='reset'>重置</a-button>
          <a-button icon="upload" style="height:32px;margin-left:20px;" @click="out(6)"
            v-if='$common.AUTH("export:ssdlfyjnjtfb")'>导出</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="conmains" v-if="$common.AUTH('statis:causeFee:lists')">
      <div class="h2">费用统计</div>
      <div class="con">
        <!-- <div class="li"><div class="tit">待还款总额(元)</div><div class="p">{{ static.sum  | showYuan}}</div></div> -->
        <div class="li">
          <div class="tit">诉讼费(元)</div>
          <div class="p">{{ rPrice(1) | showYuan }}</div>
        </div>
        <div class="li">
          <div class="tit">上诉费(元)</div>
          <div class="p">{{ rPrice(10) | showYuan }}</div>
        </div>
        <div class="li">
          <div class="tit">公告费(元)</div>
          <div class="p">{{ rPrice(2) | showYuan }}</div>
        </div>
        <div class="li">
          <div class="tit">保全费(元)</div>
          <div class="p">{{ rPrice(3) | showYuan }}</div>
        </div>
        <div class="li">
          <div class="tit">律师费(元)</div>
          <div class="p">{{ rPrice(4) | showYuan }}</div>
        </div>
        <div class="li">
          <div class="tit">差旅费(元)</div>
          <div class="p">{{ rPrice(5) | showYuan }}</div>
        </div>
        <!-- <div class="li">
          <div class="tit">执行费(元)</div>
          <div class="p">{{ rPrice(12) | showYuan }}</div>
        </div> -->
        <div class="li">
          <div class="tit">评估费(元)</div>
          <div class="p">{{ rPrice(13) | showYuan }}</div>
        </div>
        <div class="li">
          <div class="tit">其他(元)</div>
          <div class="p">{{ rPrice(7) | showYuan }}</div>
        </div>
      </div>
      <div class="tcon">
        <div class="tableList">
          <div class="table">
            <table>
              <thead>
                <td style="width: 70px;">序号</td>
                <td style="width: 70px;">被告</td>
                <td style="width: 160px;">证件号码/代码</td>
                <td style="width: 65px;">所属案件</td>
                <td width="200">原告</td>
                <td width="210">管辖法院</td>
                <td width="120">付款阶段</td>
                <td width="100">付款构成</td>
                <td width="140">付款时间</td>
              </thead>
              <tbody>
                <tr v-for='(i, index) in newO.list' :key='index'>
                  <td>{{ index + 1 + (10 * (page.page - 1)) }}</td>
                  <td>
                    <span class="curpoter" @click='dbclick(i)'>
                      <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                    </span>
                  </td>
                  <td>
                    <p>
                      <Normap :tit='i.chinaid'>{{ i.chinaid }}</Normap>
                    </p>
                  </td>
                  <td>
                    <p v-for='(j, index) in i.cause' :key="index" :style="{ 'height': j.height + 'px' }">
                      案件{{ j.sort }}
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index" :style="{ 'height': j.height + 'px' }">
                      <Normap :tit='j.accuser ? j.accuser.title : "/"'></Normap>
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index" :style="{ 'height': j.height + 'px' }">
                      <Normap :tit='j.court'></Normap>
                    </p>
                  </td>
                  <td>
                    <div class="p" v-for="(ele, index) in i.cause" :key="index"
                      :style="{ 'height': ele.height + 'px' }">
                      <div class="np" v-for="(k, index) in ele.step_dkt" :key="index">
                        <Normap :tit='k.title'></Normap>
                      </div>
                    </div>
                  </td>
                  <td>
                    <!-- <div class="p" v-for="(ele, index) in i.cause" :key="index"
                      :style="{ 'height': ele.height + 'px' }">
                      <div class="np" v-for="(j, index) in ele.step_dkt" :key="index">
                        <a-popover>
                          <template slot="content">
                            <div class="contbox">
                              <p v-for='(k, index) in j.fee' :key="index">{{ k.type_title }}:{{ k.fee | showYuan }}</p>
                            </div>
                          </template>
<span>{{ allPrice(j.fee) | showYuan }}</span>
</a-popover>
</div>
</div> -->
                    <div class="p" v-for="(ele, index) in i.cause" :key="index"
                      :style="{ 'height': ele.height + 'px' }">
                      <div class="np" v-for="(j, index) in ele.step_dkt" :key="index">
                        <a-popover>
                          <template slot="content">
                            <div class="contbox">
                              <p v-for='(k, ind) in j.fee' :key="ind" class="fee-p">{{ k.type_title }}:{{ k.fee |
                                showYuan }}</p>
                            </div>
                          </template>
                          <span>{{ allPrice(j.fee) | showYuan }}</span>
                        </a-popover>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="p" v-for="(ele, index) in i.cause" :key="index"
                      :style="{ 'height': ele.height + 'px' }">
                      <div class="np" v-for="(k, index) in ele.step_dkt" :key="index">
                        <Normap :tit='k.fee[0].time'></Normap>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pages">
            <a-pagination v-model="page.page" show-quick-jumper :total="newO.debtor_count" show-less-items
              :pageSize='10' @change='turnpage'
              :show-total="(total) => `被告：${newO.debtor_count} 案件数：${newO.cause_count}`" />
          </div>
        </div>

      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import { getAccuserAll } from '@/server/api'
import { getDirectory } from "@/server/directory"
import { statisDktFee, statisDktFeeList } from '@/server/collection'
import { exportForm } from '@/assets/js/unit'
export default {
  data() {
    return {
      newO: {
        cause_count: 0,
        debtor_count: 0,
        list: [],
      },
      page: {
        page: 1,
        limit: 10,
      },
      courtList: [],
      accuserList: [],
      form: {
        team_id: [],
        accuser_id: [],
        court_id: [],
        stime: '',
        etime: ''
      },
      priceList: []
    }
  },
  created() {
    this.query()
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    this.handleSearch('')
  },
  methods: {
    allPrice(arr) {
      if (arr) {
        let money = arr.reduce((prev, next) => {
          return prev + next.fee
        }, 0)
        return money;
      } else {
        return 0
      }
    },
    rPrice(type) {
      const price = this.priceList.find(ele => {
        return ele.type == type
      })
      if (price) return price.fee
      else return 0
    },
    handleSearch(val) {
      getDirectory({
        limit: 100,
        title: val
      }).then((res) => {
        this.courtList = res.list
      })
    },
    turnpage(val) {
      this.form.page = val
      this.query()
    },
    out(type) {
      if (this.form.payee_date_start && this.form.payee_date_end) {
        const form = JSON.parse(JSON.stringify(this.form));
        exportForm(type, form)
      } else {
        this.$message.error('请先选择时间再执行导出');
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.payee_date_start = e.stime
      } else {
        this.form.payee_date_end = e.etime
      }
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({
          "name": "lydetails",
          params: {
            "id": record.cause[0].debtor_id
          }
        });
        window.open(routeUrl.href, '_blank');
      } else {
        this.$message.error({
          content: '暂无权限',
          key: 'updatable'
        });
      }
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      form.court_id = form.court_id.toString()
      statisDktFee(form).then(e => {
        this.priceList = e;
      })
      this.getList()
    },
    reset() {
      this.form.page = 1
      this.page.page = 1
      this.form.cause_type = undefined
      this.form.accuser_id = []
      this.form.court_id = []
      this.form.payee_date_start = ''
      this.form.payee_date_end = ''
      this.$refs.timePicker.clearTime()
      this.query()
    },
    getList() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.page = this.page.page;
      form.limit = this.page.limit;
      form.accuser_id = form.accuser_id.toString()
      form.court_id = form.court_id.toString()
      statisDktFeeList(form).then(e => {
        e.list.map(ele => {
          ele.cause.map(s => {
            const stepNum = s.step_dkt.length * (10 + s.step_dkt.length * 5);
            s.height = stepNum + 60
          })
        })
        this.newO = e;
      })
    }
  }
}
</script>
<style lang="less" scoped>
.contbox {
  display: flex;
  // width: 510px;
  // padding: 0 10px;
  box-sizing: border-box;
  background: #ffffff;
  flex-wrap: wrap;

  p {
    font-size: 0.875rem;
    margin-bottom: 0;
    line-height: 30px;
    // margin-right: 20px;
  }
}

.caseStatistics {
  // padding-bottom: 50px;
  @import url('@/assets/css/search.less');
}

.h2 {
  line-height: 62px;
  padding-left: 20px;
  font-size: 1rem;
  color: #0e2949;
  font-weight: bold;
  border-bottom: 1px solid #efefef;
}

.conmains {
  margin-top: 10px;
  background: #fff;

  .con {
    height: 105px;
    display: flex;
    background: #F6F8FC;
    margin: 20px 20px 0;

    .li {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      flex-direction: column;

      &:nth-last-child(1) {
        width: 10%;
      }

      .tit {
        font-size: 0.875rem;
        font-weight: 500;
        color: #0E2949;
        line-height: 20px;
      }

      .p {
        font-size: 0.875rem;
        font-weight: 500;
        margin-top: 5px;
        color: #0E2949;
        line-height: 20px;
      }
    }
  }
}

.tcon {
  padding: 0 20px;
  margin-top: 20px;
  min-height: 720px;

  .tableList {
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p,
          .p {
            vertical-align: middle;
            padding: 10px 0 10px 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }

          .p {
            display: flex;
            justify-content: center;
            flex-direction: column;
          }

          .np {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-bottom: 1px solid #ebebeb;
            padding: 10px 0;

            &:nth-last-child(1) {
              border: 0 none;
            }

          }
        }
      }
    }
  }
}

.fee-p:not(:last-child) {
  margin-right: 20px;
}

.pages {
  text-align: right;
  position: relative;
}
</style>
